import type { Response, SuperAgentRequest } from 'superagent';
import request from '../../../util/SuperagentUtils';

type OnSuccess = (response: Response) => void;
type OnFail = (error: unknown) => void;

interface BookingApprovalsSearchParams {
    supplierAccountId: string;
}

interface ApproveBookingBody {
    bookingId: string;
}

interface DeclineBookingBody {
    bookingId: string;
    reasonDeclined: string;
    reasonDeclinedNote: string;
}

interface BookingStatusData {
    status: string;
    body: object;
}

// Callers either use the returned request (no callbacks) or pass both callbacks.

function getBookingApprovals(searchParams: BookingApprovalsSearchParams): SuperAgentRequest;
function getBookingApprovals(searchParams: BookingApprovalsSearchParams, onSuccess: OnSuccess, onFail: OnFail): void;
function getBookingApprovals(searchParams: BookingApprovalsSearchParams, onSuccess?: OnSuccess, onFail?: OnFail): SuperAgentRequest | void {

    const { supplierAccountId } = searchParams;

    const result = request.get(`/api/booking?supplierAccountId=${supplierAccountId}&approvalsOnly=true`);

    if (onSuccess && onFail) {
        result
            .then(onSuccess)
            .catch(onFail)
    } else {
        return result
    }
}

function bookingStatus(data: BookingStatusData): SuperAgentRequest;
function bookingStatus(data: BookingStatusData, onSuccess: OnSuccess, onFail: OnFail): void;
function bookingStatus(data: BookingStatusData, onSuccess?: OnSuccess, onFail?: OnFail): SuperAgentRequest | void {
    const { status, body} = data;
    
    const result = request.post(`/api/booking/${status}`).send(body);

    if (onSuccess && onFail) {
        result
            .then(onSuccess)
            .catch(onFail)
    } else {
        return result
    }
}

function approveBooking(body: ApproveBookingBody): SuperAgentRequest;
function approveBooking(body: ApproveBookingBody, onSuccess: OnSuccess, onFail: OnFail): void;
function approveBooking(body: ApproveBookingBody, onSuccess?: OnSuccess, onFail?: OnFail): SuperAgentRequest | void {
    
    const result = request.post(`/api/booking/approve`).send(body);

    if (onSuccess && onFail) {
        result
            .then(onSuccess)
            .catch(onFail)
    } else {
        return result
    }
}

function declineBooking(body: DeclineBookingBody): SuperAgentRequest;
function declineBooking(body: DeclineBookingBody, onSuccess: OnSuccess, onFail: OnFail): void;
function declineBooking(body: DeclineBookingBody, onSuccess?: OnSuccess, onFail?: OnFail): SuperAgentRequest | void {
    
    const result = request.post(`/api/booking/decline`).send(body);

    if (onSuccess && onFail) {
        result
            .then(onSuccess)
            .catch(onFail)
    } else {
        return result
    }
}

const getBookingDeclineReasons = (): SuperAgentRequest => {
    return request.get(`/api/booking/declined-reasons`)
}

export {
    getBookingApprovals,
    bookingStatus,
    approveBooking,
    declineBooking,
    getBookingDeclineReasons
}